import DocumentTemplateListPage from './DocumentTemplateListPage'

const documentTemplateRoutes = [
  {
    breadcrumb: 'Template Management',
    path: '',
    element: <DocumentTemplateListPage />,
    children: [],
  },
]

export default documentTemplateRoutes
